module.exports = __webpack_public_path__ + "img/notepad-02.352d2926.png";